export function CrossMark({
  className = '',
  style = null,
  color = 'white',
  opacity = 0.7
}) {
  return (
    <div className={`icon ${className}`} style={style}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_462_827)">
          <path d="M8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16H16V8C16 3.58867 12.4113 0 8 0ZM15.3333 15.3333H8C3.95667 15.3333 0.666667 12.0433 0.666667 8C0.666667 3.95667 3.95667 0.666667 8 0.666667C12.0433 0.666667 15.3333 3.95667 15.3333 8V15.3333Z" fill={color} fillOpacity={opacity}/>
          <path d="M11.0803 10.979L8.64315 8.54185L11.0803 6.10471L10.5387 5.56312L8.10156 8.00027L5.66442 5.56312L5.12283 6.10471L7.55997 8.54185L5.12283 10.979L5.66442 11.5206L8.10156 9.08344L10.5387 11.5206L11.0803 10.979Z" fill={color} fillOpacity={opacity}/>
        </g>
        <defs>
          <clipPath id="clip0_462_827">
            <rect width="16" height="16" fill={color}/>
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}
